import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
  state: () => ({
    navBarVisible: true
  }),
  actions: {
    toggleNavBar() {
      this.navBarVisible = !this.navBarVisible
    }
  }
})
